document.addEventListener('DOMContentLoaded', () => {
  const forms = document.querySelectorAll('.editorial-variant-form');
  forms.forEach((form) => {
    const variantsJson = form.querySelector('[data-variants]');
    const optionsJson = form.querySelector('[data-options]');
    if (!variantsJson || !optionsJson) return;

    const variants = JSON.parse(variantsJson.textContent);
    const options = JSON.parse(optionsJson.textContent);
    const addButton = form.querySelector('.btn-add-to-cart');
    const variantInput = form.querySelector('input[name="id"]');
    const swatchesContainer = form.querySelector('.variant-selectors');

    const isVariantSellable = (variant) => {
      if (!variant) return false;
      if (variant.ocultar_variante === true || variant.ocultar_variante === 'true') return false;
      if (variant.available !== true) return false;


      const stockRaw = variant.stock_cd_raindoor;
      if (stockRaw === '' || stockRaw === null || stockRaw === undefined) return true;

      const stockNum = parseFloat(stockRaw);
      if (Number.isNaN(stockNum)) return true;
      return stockNum > 0;
    };

    const updateAddButton = () => {
      const selectedOptions = getSelectedOptions(form);
      const selectedVariant = findVariant(variants, options, selectedOptions);

      if (selectedVariant && isVariantSellable(selectedVariant)) {
        variantInput.value = selectedVariant.id;
      }

      if (!addButton) return;

      const anyVariantAvailable = variants.some((v) => isVariantSellable(v));

      if (!anyVariantAvailable) {
        addButton.disabled = true;
        addButton.textContent = 'No disponible';
        addButton.classList.add('unavailable');
        return;
      }

      if (!selectedVariant) {
        addButton.disabled = true;
        addButton.textContent = 'Selecciona opciones';
        addButton.classList.remove('unavailable');
        return;
      }

      if (isVariantSellable(selectedVariant)) {
        addButton.disabled = false;
        addButton.textContent = 'Agregar al carro';
        addButton.classList.remove('unavailable');
      } else {
        addButton.disabled = true;
        addButton.textContent = 'No disponible';
        addButton.classList.add('unavailable');
      }
    };

    const getSelectedOptions = (form) => {
      const selected = {};
      form.querySelectorAll('.swatch.active').forEach((swatch) => {
        selected[swatch.dataset.option] = swatch.dataset.value;
      });
      return selected;
    };

    const findVariant = (variants, options, selected) => {
      return variants.find((variant) => {
        return options.every((opt, index) => {
          const selValue = selected[opt];
          return !selValue || variant.options[index] === selValue;
        });
      });
    };

    swatchesContainer.addEventListener('click', (e) => {
      if (!e.target.matches('.swatch') || e.target.classList.contains('disabled')) return;
      const optionName = e.target.dataset.option;
      form.querySelectorAll(`.swatch[data-option="${optionName}"]`).forEach((s) => s.classList.remove('active'));
      e.target.classList.add('active');
      updateAddButton();
      
      // Auto-submit form when a swatch is clicked (Direct add to cart)
      form.dispatchEvent(new Event('submit'));
    });

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (addButton && addButton.disabled) return;

      const variantId = variantInput.value;
      const oldText = addButton ? addButton.textContent : 'Agregando...';
      if (addButton) {
        addButton.disabled = true;
        addButton.textContent = 'Agregando...';
      }

      fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] }),
      })
        .then((res) => res.json())
        .then(() => fetch(`${window.Shopify.routes.root}?section_id=cart-drawer`).then((res) => res.text()))
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newDrawer = doc.querySelector('cart-drawer');
          if (newDrawer) {
            const currentDrawer = document.querySelector('cart-drawer');
            if (currentDrawer) currentDrawer.outerHTML = newDrawer.outerHTML;
          }
          
          fetch(`${window.Shopify.routes.root}?section_id=cart-icon-bubble`)
            .then(res => res.text())
            .then(html => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const newBubble = doc.querySelector('.shopify-section');
              if (newBubble) {
                const currentBubble = document.querySelector('#cart-icon-bubble');
                if (currentBubble) currentBubble.innerHTML = newBubble.innerHTML;
              }
            });
          
          setTimeout(() => {
            const drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.open === 'function') drawer.open();
          }, 100);

          if (addButton) addButton.textContent = '¡Agregado!';
          setTimeout(() => {
            if (addButton) {
              addButton.textContent = oldText;
              addButton.disabled = false;
            }
            // Close the selector after adding
            const block = form.closest('.editorial-block');
            if (block) {
              block.classList.remove('active');
              const plusToggle = block.querySelector('.editorial-plus-toggle');
              if (plusToggle) plusToggle.textContent = '+';
            }
          }, 1500);
          document.dispatchEvent(new CustomEvent('cart:updated'));
        })
        .catch((err) => {
          console.error('Error:', err);
          if (addButton) {
            addButton.textContent = 'Error';
            setTimeout(() => {
              addButton.textContent = oldText;
              addButton.disabled = false;
            }, 1500);
          }
        });
    });

    updateAddButton();
  });

  // New Toggle and Close logic
  console.log('Editoriales JS: Registering toggles');
  const plusToggles = document.querySelectorAll('.editorial-plus-toggle, .close-overlay');
  plusToggles.forEach((toggle) => {
    toggle.addEventListener('click', (e) => {
      console.log('Editoriales JS: Toggle clicked', toggle);
      const block = toggle.closest('.editorial-block');
      if (!block) {
        console.error('Editoriales JS: No .editorial-block found for toggle');
        return;
      }
      
      e.preventDefault();
      e.stopPropagation();

      const isActive = block.classList.contains('active');
      if (isActive || toggle.classList.contains('close-overlay')) {
        console.log('Editoriales JS: Closing block');
        block.classList.remove('active');
        const mainToggle = block.querySelector('.editorial-plus-toggle:not(.close-overlay)');
        if (mainToggle) mainToggle.textContent = '+';
      } else {
        console.log('Editoriales JS: Opening block');
        // Close others
        document.querySelectorAll('.editorial-block.active').forEach(b => {
          b.classList.remove('active');
          const t = b.querySelector('.editorial-plus-toggle:not(.close-overlay)');
          if (t) t.textContent = '+';
        });
        block.classList.add('active');
        toggle.textContent = '-';
      }
    });
  });

  document.addEventListener('click', (e) => {
    const active = document.querySelector('.editorial-block.active');
    if (!active) return;
    if (!active.contains(e.target)) {
      active.classList.remove('active');
      const toggle = active.querySelector('.editorial-plus-toggle:not(.close-overlay)');
      if (toggle) toggle.textContent = '+';
    }
  });
});